import { cssWhen } from '../../utils/themeUtils';
import classes from './EndAdornment.module.scss';

export interface NbEndAdornmentProps {
  text: string;
  placement: 'start' | 'end';
}

export const NbEndAdornment = ({ text, placement }: NbEndAdornmentProps) => {
  return (
    <span
      className={cssWhen(
        classes.adornment,
        [placement === 'start', classes.adornmentIsStart],
        [placement === 'end', classes.adornmentIsEnd],
      )}
    >
      {text}
    </span>
  );
};
